class PostTemplate {
    getElement(post) {
        const div = document.createElement('div')
        div.innerHTML = this.getHtml(post)
        return div.firstElementChild
    }



    getHtml(post) {
        // Odkomentuj jeżeli chcesz sprawdzić dostępnę wartości na widoku
		// <div class="blog-date">
		// 	${publishedDate}
		// </div>
        // const publishedDate = new Date(post.published).toLocaleDateString();

        const { link } = post
		const publishedDate = this.formatDate(post.published)

        const image = post.imageLink ? /* html */ `
			<picture>
				<img src="${post.imageLink}" alt="${post.title}" title="${post.title}" class="blog-img">
			</picture>
		` : ''

        return /* html */ `
			 <div class = "col-12 col-lg-6 col-xl-4 blog-item-wrapper">
				<div class="blog-item">
					   <div class="blog-img-wrapper">
             <a class="" href="${link}" >
                  		${image}
               </a>
			   <div class="blog-date">
			   <p>${publishedDate}</p>
			   </div>
           </div>

					<div class="inner-wrapper">


						<div class="blog-text">
							<a class="blog-title-link" href="${link}" title="${post.title}" >
								<h3 class="blog-title">${post.title}</h3>
							</a>
						</div>

						<p class="blog-readmore">${post.description}</p>

						<a class="btn btn-secondary" href="${link}" title="Sprawdź inspirację od Sievert Polska">
			Przejdź do wpisu
			</a>





					</div>
				</div>
			</div>
		`
    }
	formatDate(dateString) {
        const [year, month, day] = dateString.split('-');
        return `${day}.${month}.${year}`;
    }
}

const postTemplate = new PostTemplate()
export {
    PostTemplate,
    postTemplate
}



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_async_posts_loader/template/PostTemplate.js